import type { ReactNode } from "react";
import { QueryClientProvider, HydrationBoundary, type DehydratedState, type QueryClient } from "@tanstack/react-query";
import type { TRPCClient } from "@trpc/client";
import type { AppRouter } from "../../server/routers";
import { HelmetProvider } from "react-helmet-async";
import { Router } from "wouter";
import { trpc } from "@/lib/trpc";

export function AppProviders({ children, queryClient, trpcClient, state, ssrPath, ssrSearch }: {
  children: ReactNode;
  queryClient: QueryClient;
  trpcClient: TRPCClient<AppRouter>;
  state?: DehydratedState;
  ssrPath?: string;
  ssrSearch?: string;
}) {
  return (
    <HelmetProvider>
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <HydrationBoundary state={state}>
            <Router ssrPath={ssrPath} ssrSearch={ssrSearch}>
              {children}
            </Router>
          </HydrationBoundary>
        </QueryClientProvider>
      </trpc.Provider>
    </HelmetProvider>
  );
}
